<template>
  <div>
    <titleSeeting :active="active" class="setting" />
    <div v-if="!proDetail.is_synchro_edc">
      <div class="first">
        <div class="title"><span class="circle" />受试者随机号设置</div>
        <div class="detail">
          <!--筛选号-->
          <div>
            <el-row class="item">
              <el-col :span="4" class="right">
                <el-input
                  v-model="choice_code_another_name"
                  size="mini"
                  type="text"
                  :disabled="isLock"
                />
              </el-col>
              <el-col :span="18" class="rights">
                ：
                <el-checkbox
                  v-model="is_choice_code_system"
                  :disabled="isLock"
                  @change="isSystem"
                  >系统生成</el-checkbox
                >
              </el-col>
            </el-row>
            <el-row class="item">
              <el-col :span="8" style="text-align: left">
                <el-row>
                  <el-col :span="7" class="right" style="text-align: right"
                    >是否需要前缀：</el-col
                  >
                  <el-col :span="12" class="rights">
                    <el-radio-group
                      v-model="is_need_choice_code_prefix"
                      :disabled="isLock"
                      @change="handleIsPrefix"
                    >
                      <el-radio :label="true">是</el-radio>
                      <el-radio :label="false">否</el-radio>
                    </el-radio-group>
                  </el-col>
                </el-row>
              </el-col>
              <el-col :span="8">
                <el-row :gutter="5">
                  <el-col :span="6" class="right" style="text-align: right"
                    >前缀：</el-col
                  >
                  <el-col :span="6">
                    <el-input
                      v-model="choice_code_prefix"
                      size="mini"
                      :disabled="disPrefix || isLock"
                    />
                  </el-col>
                  <el-col :span="12">
                    <el-select
                      v-model="choice_code_prefix_type"
                      placeholder="请选择"
                      size="mini"
                      :disabled="disPrefix || isLock"
                    >
                      <el-option
                        v-for="(item, e) in unit"
                        :key="e"
                        :label="item.name"
                        :value="item.name"
                      />
                    </el-select>
                  </el-col>
                </el-row>
              </el-col>
              <el-col :span="8">
                <el-row>
                  <el-col :span="6" class="right">前缀分隔符：</el-col>
                  <el-col :span="8">
                    <el-input
                      v-model="choice_code_prefix_sep"
                      size="mini"
                      :disabled="disPrefix || isLock"
                      type="text"
                    />
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
            <el-row class="item">
              <el-col :span="8">
                <el-row>
                  <el-col :span="7" class="right" style="text-align: right"
                    >编号长度：</el-col
                  >
                  <el-col :span="12">
                    <el-input
                      v-model="choice_code_len"
                      size="mini"
                      :disabled="isLock"
                    />
                  </el-col>
                </el-row>
              </el-col>
              <el-col :span="8">
                <el-row>
                  <el-col :span="6" class="right" style="text-align: right"
                    >起始编号：</el-col
                  >
                  <el-col :span="14">
                    <el-input
                      v-model="choice_code_start"
                      size="mini"
                      :disabled="disableSys || isLock"
                    />
                  </el-col>
                </el-row>
              </el-col>
              <el-col :span="8">
                <el-row>
                  <el-col :span="6" class="right">编号规则：</el-col>
                  <el-col :span="12">
                    <el-select
                      v-model="choice_code_type"
                      placeholder="请选择"
                      size="mini"
                      :disabled="disableSys || isLock"
                    >
                      <el-option
                        v-for="(item, a) in choiceList"
                        :key="a"
                        :label="item.name"
                        :value="item.name"
                      />
                    </el-select>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
            <el-row class="item">
              <el-col :span="8">
                <el-row>
                  <el-col :span="7" class="right" style="text-align: right"
                    >是否需要后缀：</el-col
                  >
                  <el-col :span="12" class="rights">
                    <el-radio-group
                      v-model="is_need_choice_code_suffix"
                      :disabled="isLock"
                      @change="handelIsSuffix"
                    >
                      <el-radio :label="true">是</el-radio>
                      <el-radio :label="false">否</el-radio>
                    </el-radio-group>
                  </el-col>
                </el-row>
              </el-col>
              <el-col :span="8">
                <el-row :gutter="5">
                  <el-col :span="6" class="right" style="text-align: right"
                    >后缀：</el-col
                  >
                  <el-col :span="6">
                    <el-input
                      v-model="choice_code_suffix"
                      size="mini"
                      :disabled="disSuffix || isLock"
                    />
                  </el-col>
                  <el-col :span="12">
                    <el-select
                      v-model="choice_code_suffix_type"
                      placeholder="请选择"
                      size="mini"
                      :disabled="disSuffix || isLock"
                    >
                      <el-option
                        v-for="(item, b) in choiceType"
                        :key="b"
                        :label="item.label"
                        :value="item.value"
                      />
                    </el-select>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
      <!--姓名-->
      <div class="three">
        <div class="detail">
          <el-row class="item">
            <el-col :span="8">
              <el-row>
                <el-col :span="8" class="right">
                  <el-input
                    v-model="initials_another_name"
                    size="mini"
                    :disabled="isLock"
                  />
                </el-col>
                <el-col :span="12" class="rights">
                  ：
                  <el-checkbox
                    v-model="is_initials_len_enforce"
                    :disabled="isLock"
                    >强制位数</el-checkbox
                  >
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="8">
              <el-row>
                <el-col :span="8" class="right">姓名缩写长度：</el-col>
                <el-col :span="12">
                  <el-select
                    v-model="initials_len"
                    placeholder="请选择"
                    size="mini"
                    :disabled="isLock"
                  >
                    <el-option
                      v-for="(item, w) in ageList"
                      :key="w"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
        </div>
      </div>
      <!--随机号-->
      <div class="two">
        <div class="detail">
          <el-row class="item">
            <el-col :span="4" class="right">
              <el-input
                v-model="random_code_another_name"
                size="mini"
                type="text"
                :disabled="isLock"
              />
            </el-col>
            <el-col :span="18" class="rights">
              ：
              <el-checkbox v-model="is_same" :disabled="isLock"
                >与{{ choice_code_another_name }}一致
              </el-checkbox>
              <el-checkbox
                v-model="is_random_code_system"
                :disabled="disAllRandom || isLock"
                @change="handleRan"
                >系统生成
              </el-checkbox>
            </el-col>
          </el-row>
          <el-row class="item">
            <el-col :span="8">
              <el-row>
                <el-col :span="7" class="right">是否需要前缀：</el-col>
                <el-col :span="12" class="rights">
                  <el-radio-group
                    v-model="is_need_random_code_prefix"
                    :disabled="disAllRandom || isLock"
                    @change="handleSuffix"
                  >
                    <el-radio :label="true">是</el-radio>
                    <el-radio :label="false">否</el-radio>
                  </el-radio-group>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="8">
              <el-row :gutter="5">
                <el-col :span="4" class="right">前缀：</el-col>
                <el-col :span="6">
                  <el-input
                    v-model="random_code_prefix"
                    size="mini"
                    :disabled="disAllRandom || isShowSuffix || isLock"
                  />
                </el-col>
                <el-col :span="12">
                  <el-select
                    v-model="random_code_prefix_type"
                    placeholder="请选择"
                    size="mini"
                    :disabled="disAllRandom || isShowSuffix || isLock"
                  >
                    <el-option
                      v-for="(item, q) in unit"
                      :key="q"
                      :label="item.name"
                      :value="item.name"
                    />
                  </el-select>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="8">
              <el-row>
                <el-col :span="6" class="right">前缀分隔符：</el-col>
                <el-col :span="8">
                  <el-input
                    v-model="random_code_prefix_sep"
                    size="mini"
                    :disabled="disAllRandom || isShowSuffix || isLock"
                  />
                </el-col>
              </el-row>
            </el-col>
          </el-row>
          <el-row class="item">
            <el-col :span="8">
              <el-row>
                <el-col :span="6" class="right">编号长度：</el-col>
                <el-col :span="12">
                  <el-input
                    v-model="random_code_len"
                    size="mini"
                    :disabled="disAllRandom || isLock"
                  />
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="8">
              <el-row>
                <el-col :span="6" class="right">起始编号：</el-col>
                <el-col :span="12">
                  <el-input
                    v-model="random_code_start"
                    size="mini"
                    :disabled="disRandom || disAllRandom || isLock"
                  />
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="8">
              <el-row>
                <el-col :span="6" class="right">编号规则：</el-col>
                <el-col :span="12">
                  <el-select
                    v-model="random_code_type"
                    placeholder="请选择"
                    :disabled="disRandom || disAllRandom || isLock"
                    size="mini"
                  >
                    <el-option
                      v-for="(item, v) in choiceList"
                      :key="v"
                      :label="item.name"
                      :value="item.name"
                    />
                  </el-select>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
          <el-row class="item">
            <el-col :span="8">
              <el-row>
                <el-col :span="7" class="right">是否需要后缀：</el-col>
                <el-col :span="12" class="rights">
                  <el-radio-group
                    v-model="is_need_random_code_suffix"
                    :disabled="disAllRandom || isLock"
                    @change="handelRandomName"
                  >
                    <el-radio :label="true">是</el-radio>
                    <el-radio :label="false">否</el-radio>
                  </el-radio-group>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="8">
              <el-row :gutter="5">
                <el-col :span="4" class="right">后缀：</el-col>
                <el-col :span="6">
                  <el-input
                    v-model="random_code_suffix"
                    size="mini"
                    :disabled="disAllRandom || suffixLast || isLock"
                  />
                </el-col>
                <el-col :span="10">
                  <el-select
                    v-model="random_code_suffix_type"
                    placeholder="请选择"
                    size="mini"
                    :disabled="disAllRandom || suffixLast || isLock"
                  >
                    <el-option
                      v-for="(item, m) in choiceType"
                      :key="m"
                      :label="item.value"
                      :value="item.value"
                    />
                  </el-select>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
    <!-- <div class="four">
      <div class="title"><span class="circle" />入组时间设置</div>
      <div class="detail">
        <div class="detailBox">
          <div class="detailTitle" style="width: 20%">
            <el-input
              v-model="in_group_time_name"
              :disabled="isLock"
              size="mini"
            ></el-input>
          </div>
          <el-row class="item">
            <el-col :span="8">
              <el-radio
                v-model="is_fix_in_group_time"
                :label="false"
                :disabled="isLock"
                >日期可自选</el-radio
              >
            </el-col>
            <el-col :span="8">
              <el-radio
                v-model="is_fix_in_group_time"
                :label="true"
                :disabled="isLock"
                >日期为当天不可自选</el-radio
              >
            </el-col>
          </el-row>
        </div>
      </div>
    </div> -->
    <!--表单导出设置-->
    <div class="four">
      <div class="title"><span class="circle" />表单导出设置</div>
      <div class="detail">
        <div class="detailBox">
          <div class="detailTitle">受试者登记单</div>
          <el-row class="item">
            <el-col :span="8">
              <el-row :gutter="5">
                <el-col :span="7" class="right">是否显示系统信息：</el-col>
                <el-col :span="12" class="rights">
                  <el-radio-group
                    v-model="is_subject_show_system"
                    :disabled="isLock"
                  >
                    <el-radio :label="true">是</el-radio>
                    <el-radio :label="false">否</el-radio>
                  </el-radio-group>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="8">
              <el-row :gutter="5">
                <el-col :span="7" class="right">是否显示导出时间：</el-col>
                <el-col :span="12" class="rights">
                  <el-radio-group
                    v-model="is_subject_show_time"
                    :disabled="isLock"
                  >
                    <el-radio :label="true">是</el-radio>
                    <el-radio :label="false">否</el-radio>
                  </el-radio-group>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="8">
              <el-row :gutter="5">
                <el-col :span="7" class="right">是否显示导出人员：</el-col>
                <el-col :span="12" class="rights">
                  <el-radio-group
                    v-model="is_subject_show_user"
                    :disabled="isLock"
                  >
                    <el-radio :label="true">是</el-radio>
                    <el-radio :label="false">否</el-radio>
                  </el-radio-group>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
        </div>
        <div>
          <div class="detailTitle">紧急揭盲登记单</div>
          <el-row class="item">
            <el-col :span="8">
              <el-row :gutter="5">
                <el-col :span="7" class="right">是否显示系统信息：</el-col>
                <el-col :span="12" class="rights">
                  <el-radio-group
                    v-model="is_urgently_unblind_show_system"
                    :disabled="isLock"
                  >
                    <el-radio :label="true">是</el-radio>
                    <el-radio :label="false">否</el-radio>
                  </el-radio-group>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="8">
              <el-row :gutter="5">
                <el-col :span="7" class="right">是否显示导出时间：</el-col>
                <el-col :span="12" class="rights">
                  <el-radio-group
                    v-model="is_urgently_unblind_show_time"
                    :disabled="isLock"
                  >
                    <el-radio :label="true">是</el-radio>
                    <el-radio :label="false">否</el-radio>
                  </el-radio-group>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="8">
              <el-row :gutter="5">
                <el-col :span="7" class="right">是否显示导出人员：</el-col>
                <el-col :span="12" class="rights">
                  <el-radio-group
                    v-model="is_urgently_unblind_show_user"
                    :disabled="isLock"
                  >
                    <el-radio :label="true">是</el-radio>
                    <el-radio :label="false">否</el-radio>
                  </el-radio-group>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
    <!--操作区-->
    <el-row class="footer">
      <el-button size="mini" style="width: 100px" type="primary" @click="goBack"
        >上一步</el-button
      >
      <el-button
        v-preventReClick
        style="width: 100px"
        size="mini"
        type="primary"
        @click="save"
        :disabled="isLock"
        >保存</el-button
      >
    </el-row>
  </div>
</template>

<script>
import titleSeeting from "./component/titleSeeting";
import { dataSetting, dataSettingTwo } from "@/api/random";
import { getProjectId, setFront, setAfter, getProDetail } from "@/utils/auth";
import { detailPro } from "@/api/platform";

export default {
  name: "Datas",
  components: {
    titleSeeting,
  },
  data() {
    return {
      active: 3,
      in_group_time_name: "入组时间",
      is_fix_in_group_time: false,
      choice_code_another_name: "筛选号", // 筛选号别名设置
      random_code_another_name: "随机号", // 随机号：别名设置
      is_choice_code_system: false, // 筛选号 是否系统生成
      is_need_choice_code_prefix: true, // 是否需要受试者筛选号前缀
      choice_code_prefix: "", // 筛选号前缀
      choice_code_prefix_type: "", // 筛选号前缀类型
      choice_code_prefix_sep: "", // 筛选号前缀分隔
      // 前缀长度
      choice_code_len: null, // 筛选号编号长度
      choice_code_start: null, // 选号编号起始编号
      choice_code_type: "项目连续", // 筛选号编号规则
      is_need_choice_code_suffix: true, // 是否需要受试者筛选号后缀
      choice_code_suffix: "", //  筛选号后缀
      choice_code_suffix_type: "", // 筛选号后缀类型
      initials_len: 3, // 姓名缩写长度
      is_initials_len_enforce: true, // 是否强制尾数
      is_same: false, // 是否与筛选号一致
      is_random_code_system: true, // 随机号 是否系统生成
      is_need_random_code_prefix: true, // 是否需要随机号前缀
      random_code_prefix: "", // 随机号前缀
      random_code_prefix_type: "", // 机号前缀类型
      random_code_prefix_sep: "", // 随机号前缀分隔符
      random_code_len: null, // 随机号编号长度
      random_code_start: null, // 随机号编号起始编号
      random_code_type: "", // 随机号编号规则
      is_need_random_code_suffix: true, // 是否需要受试者随机号后缀
      random_code_suffix: "", // 随机号后缀
      random_code_suffix_type: "", // 随机号后缀类型
      initials_another_name: "", // 姓名缩写别名设置
      is_subject_show_system: true, // 受试者登记单，是否显示系统信息
      is_subject_show_time: true,
      is_subject_show_user: true,
      is_urgently_unblind_show_system: true, // 紧急
      is_urgently_unblind_show_time: true,
      is_urgently_unblind_show_user: true,
      unit: [{ name: "单位编号" }, { name: "空" }],
      choiceList: [{ name: "项目连续" }, { name: "中心连续" }],
      choiceType: [{ value: "姓名缩写" }, { value: "空" }],
      ageList: [
        { value: 2 },
        { value: 3 },
        { value: 4 },
        { value: 5 },
        { value: 6 },
        { value: 7 },
        { value: 8 },
        { value: 9 },
      ],
      disableSys: true,
      disPrefix: false,
      disSuffix: false,
      disRandom: true, // 随机号系统生成
      disAllRandom: false, // 与筛选号一致
      isShowSuffix: false,
      suffixLast: false,
      proId: "",
      isLock: false, // 锁定项目不可编辑,
      proDetail: getProDetail(),
    };
  },
  watch: {
    is_same: function () {
      if (this.is_same) {
        this.disAllRandom = true;
        this.is_need_random_code_prefix = this.is_need_choice_code_prefix; // 是否需要随机号前缀
        this.random_code_prefix = this.choice_code_prefix; // 随机号前缀
        this.random_code_prefix_type = this.choice_code_prefix_type; // 机号前缀类型
        this.random_code_prefix_sep = this.choice_code_prefix_sep; // 随机号前缀分隔符
        this.random_code_len = this.choice_code_len; // 随机号编号长度
        this.random_code_start = this.choice_code_start; // 随机号编号起始编号
        this.random_code_type = this.choice_code_type; // 随机号编号规则
        this.is_need_random_code_suffix = this.is_need_choice_code_suffix; // 是否需要受试者随机号后缀
        this.random_code_suffix = this.choice_code_suffix; // 随机号后缀
        this.random_code_suffix_type = this.choice_code_suffix_type; // 随机号后缀类型
        this.is_random_code_system = this.is_choice_code_system;
      } else {
        this.disAllRandom = false;
        if (this.is_random_code_system) {
          this.disRandom = false;
        } else {
          this.disRandom = true;
        }
      }
    },
    is_need_choice_code_prefix: function () {
      if (this.is_same) {
        this.is_need_random_code_prefix = this.is_need_choice_code_prefix;
      }
    },
    choice_code_prefix: function () {
      if (this.is_same) {
        this.random_code_prefix = this.choice_code_prefix;
      }
    },
    choice_code_prefix_type: function () {
      if (this.is_same) {
        this.random_code_prefix_type = this.choice_code_prefix_type;
      }
    },
    choice_code_prefix_sep: function () {
      if (this.is_same) {
        this.random_code_prefix_sep = this.choice_code_prefix_sep;
      }
    },
    choice_code_len: function () {
      if (this.is_same) {
        this.random_code_len = this.choice_code_len;
      }
    },
    choice_code_start: function () {
      if (this.is_same) {
        this.random_code_start = this.choice_code_start;
      }
    },
    choice_code_type: function () {
      if (this.is_same) {
        this.random_code_type = this.choice_code_type;
      }
    },
    is_need_choice_code_suffix: function () {
      if (this.is_same) {
        this.is_need_random_code_suffix = this.is_need_choice_code_suffix;
      }
    },
    choice_code_suffix: function () {
      if (this.is_same) {
        this.random_code_suffix = this.choice_code_suffix;
      }
    },
    choice_code_suffix_type: function () {
      if (this.is_same) {
        this.random_code_suffix_type = this.choice_code_suffix_type;
      }
    },
    is_choice_code_system: function () {
      if (this.is_same) {
        this.is_random_code_system = this.is_choice_code_system;
      }
    },
  },
  created() {
    this.proId = getProjectId();
    this.getData();
  },
  methods: {
    // 查询
    getData() {
      detailPro({ id: this.proId })
        .then((res) => {
          if (res && res.code === 0) {
            if (res.data.status === "项目创建中") {
              this.isLock = false;
            } else {
              this.isLock = true;
            }
            this.is_choice_code_system = res.data.is_choice_code_system;
            if (this.is_choice_code_system) {
              this.disableSys = false;
            } else {
              this.disableSys = true;
            }
            this.is_need_choice_code_prefix =
              res.data.is_need_choice_code_prefix;
            if (!this.is_need_choice_code_prefix) {
              this.disPrefix = true;
            }
            this.choice_code_prefix = res.data.choice_code_prefix;
            this.choice_code_prefix_type = res.data.choice_code_prefix_type;
            this.choice_code_prefix_sep = res.data.choice_code_prefix_sep;
            this.choice_code_len = res.data.choice_code_len;
            // this.in_group_time_name = res.data.in_group_time_name;
            // this.is_fix_in_group_time = res.data.is_fix_in_group_time;
            if (res.data.choice_code_start === "None") {
              this.choice_code_start = "";
            } else {
              this.choice_code_start = res.data.choice_code_start;
            }
            this.choice_code_type = res.data.choice_code_type;
            this.is_need_choice_code_suffix =
              res.data.is_need_choice_code_suffix;
            if (!this.is_need_choice_code_suffix) {
              this.disSuffix = true;
            }
            this.choice_code_suffix = res.data.choice_code_suffix;
            this.choice_code_suffix_type = res.data.choice_code_suffix_type;
            if (res.data.initials_len === 0) {
              this.initials_len = "";
            } else {
              this.initials_len = res.data.initials_len;
            }
            this.is_initials_len_enforce = res.data.is_initials_len_enforce;
            this.is_same = res.data.is_same;
            if (this.is_same) {
              this.disAllRandom = true;
            } else {
              this.disAllRandom = false;
            }
            this.is_random_code_system = res.data.is_random_code_system;
            if (this.is_random_code_system) {
              this.disRandom = false;
            } else {
              this.disRandom = true;
            }
            this.is_need_random_code_prefix =
              res.data.is_need_random_code_prefix;
            if (this.is_need_random_code_prefix) {
              this.isShowSuffix = false;
            } else {
              this.isShowSuffix = true;
            }
            this.random_code_prefix = res.data.random_code_prefix;
            this.random_code_prefix_type = res.data.random_code_prefix_type;
            this.random_code_prefix_sep = res.data.random_code_prefix_sep;
            this.random_code_len = res.data.random_code_len;
            if (res.data.random_code_start === "None") {
              this.random_code_start = "";
            } else {
              this.random_code_start = res.data.random_code_start;
            }
            this.random_code_type = res.data.random_code_type;
            this.is_need_random_code_suffix =
              res.data.is_need_random_code_suffix;
            if (!this.is_need_random_code_suffix) {
              this.suffixLast = true;
            }
            this.random_code_suffix = res.data.random_code_suffix;
            this.random_code_suffix_type = res.data.random_code_suffix_type;
            this.choice_code_another_name = res.data.choice_code_another_name;
            this.random_code_another_name = res.data.random_code_another_name;
            this.initials_another_name = res.data.initials_another_name;
            this.is_subject_show_system = res.data.is_subject_show_system;
            this.is_subject_show_time = res.data.is_subject_show_time;
            this.is_subject_show_user = res.data.is_subject_show_user;
            this.is_urgently_unblind_show_system =
              res.data.is_urgently_unblind_show_system;
            this.is_urgently_unblind_show_time =
              res.data.is_urgently_unblind_show_time;
            this.is_urgently_unblind_show_user =
              res.data.is_urgently_unblind_show_user;
          } else {
            this.$message(res.msg);
          }
        })
        .catch((res) => {
          console.log(res.msg);
        });
    },
    isSystem(val) {
      if (val) {
        this.disableSys = false;
      } else {
        this.disableSys = true;
        this.choice_code_start = null;
        this.choice_code_type = "";
      }
    },
    handleIsPrefix(val) {
      if (val) {
        this.disPrefix = false;
      } else {
        this.disPrefix = true;
        this.choice_code_prefix = "";
        this.choice_code_prefix_type = "";
        this.choice_code_prefix_sep = "";
      }
    },
    handelIsSuffix(val) {
      if (val) {
        this.disSuffix = false;
      } else {
        this.disSuffix = true;
        this.choice_code_suffix = "";
        this.choice_code_suffix_type = "";
      }
    },
    handleRan(val) {
      if (val) {
        this.disRandom = false;
      } else {
        this.disRandom = true;
        this.random_code_start = null;
        this.random_code_type = "";
      }
    },
    handleSuffix(val) {
      if (val) {
        this.isShowSuffix = false;
      } else {
        this.isShowSuffix = true;
        this.random_code_prefix_type = "";
        this.random_code_prefix = "";
        this.random_code_prefix_sep = "";
      }
    },
    handelRandomName(val) {
      if (val) {
        this.suffixLast = false;
      } else {
        this.suffixLast = true;
        this.random_code_suffix = "";
        this.random_code_suffix_type = "";
      }
    },
    goBack() {
      if (
        this.$route.query.random_type &&
        this.$route.query.section_type &&
        this.$route.query.sample_size
      ) {
        this.$router.push({
          path: "/random/parameter",
          query: {
            random_type: this.$route.query.random_type,
            section_type: this.$route.query.section_type,
            sample_size: this.$route.query.sample_size,
          },
        });
      } else {
        this.$router.push({
          path: "/random/parameter",
        });
      }
    },
    validate() {
      if (!this.choice_code_another_name) {
        this.$message({
          message: "请填写筛选号名称",
          type: "warning",
        });
        return false;
      }
      if (this.is_choice_code_system) {
        if (!this.choice_code_start) {
          this.$message({
            message: "请填写起始编号",
            type: "warning",
          });
          return false;
        }
        if (!this.choice_code_type) {
          this.$message({
            message: "请选择起始编号类型",
            type: "warning",
          });
          return false;
        }
      }
      if (this.is_need_choice_code_prefix) {
        // if (!this.choice_code_prefix) {
        //   this.$message({
        //     message: '请填写前缀',
        //     type: 'warning'
        //   })
        //   return false
        // }
        if (!this.choice_code_prefix_type) {
          this.$message({
            message: "请选择前缀类型",
            type: "warning",
          });
          return false;
        }
        // if (!this.choice_code_prefix_sep) {
        //   this.$message({
        //     message: '请填写前缀分隔符',
        //     type: 'warning'
        //   })
        //   return false
        // }
      }
      if (!this.choice_code_len) {
        this.$message({
          message: "请填写筛选号长度",
          type: "warning",
        });
        return false;
      }
      if (this.is_need_choice_code_suffix) {
        // if (!this.choice_code_suffix) {
        //   this.$message({
        //     message: '请填写后缀',
        //     type: 'warning'
        //   })
        //   return false
        // }
        if (!this.choice_code_suffix_type) {
          this.$message({
            message: "请选择后缀类型",
            type: "warning",
          });
          return false;
        }
      }
      if (!this.initials_len) {
        this.$message({
          message: "请选择姓名缩写长度",
          type: "warning",
        });
        return false;
      }
      if (!this.random_code_another_name) {
        this.$message({
          message: "请填写随机号",
          type: "warning",
        });
        return false;
      }
      if (this.is_random_code_system) {
        if (!this.random_code_start) {
          this.$message({
            message: "请填写起始编号",
            type: "warning",
          });
          return false;
        }
        if (!this.random_code_type) {
          this.$message({
            message: "请选择编号规则",
            type: "warning",
          });
          return false;
        }
      }
      if (this.is_need_random_code_prefix) {
        // if (!this.random_code_prefix) {
        //   this.$message({
        //     message: '请填写前缀',
        //     type: 'warning'
        //   })
        //   return false
        // }
        if (!this.random_code_prefix_type) {
          this.$message({
            message: "请选择前缀类型",
            type: "warning",
          });
          return false;
        }
        // if (!this.random_code_prefix_sep) {
        //   this.$message({
        //     message: '请填写前缀分隔符',
        //     type: 'warning'
        //   })
        //   return false
        // }
      }
      if (!this.random_code_len) {
        this.$message({
          message: "请填写编号长度",
          type: "warning",
        });
        return false;
      }
      if (this.is_need_random_code_suffix) {
        // if (!this.random_code_suffix) {
        //   this.$message({
        //     message: '请填写后缀',
        //     type: 'warning'
        //   })
        //   return false
        // }
        if (!this.random_code_suffix_type) {
          this.$message({
            message: "请选择后缀类型",
            type: "warning",
          });
          return false;
        }
      }
      return true;
    },
    save() {
      if (this.proDetail.is_synchro_edc) {
        const params = {
          id: this.proId,
          is_subject_show_system: this.is_subject_show_system,
          is_subject_show_time: this.is_subject_show_time,
          is_subject_show_user: this.is_subject_show_user,
          is_urgently_unblind_show_system: this.is_urgently_unblind_show_system,
          is_urgently_unblind_show_time: this.is_urgently_unblind_show_time,
          is_urgently_unblind_show_user: this.is_urgently_unblind_show_user,
          // in_group_time_name: this.in_group_time_name,
          // is_fix_in_group_time: this.is_fix_in_group_time,
        };
        this.add(params);
      } else {
        if (
          (!this.is_need_choice_code_prefix &&
            this.choice_code_type === "中心连续") ||
          (!this.is_need_random_code_prefix &&
            this.random_code_type === "中心连续")
        ) {
          this.$message.error("中心连续必须需要前缀");
          return false;
        }
        if (
          (this.is_choice_code_system &&
            this.choice_code_prefix_type === "空" &&
            this.choice_code_type === "中心连续") ||
          (this.is_random_code_system &&
            this.random_code_prefix_type === "空" &&
            this.random_code_type === "中心连续")
        ) {
          this.$message.error(
            "系统生成前缀类型不能为空且编号规则不能为中心连续"
          );
          return false;
        }
        if (this.validate()) {
          const params = {
            id: this.proId,
            is_choice_code_system: this.is_choice_code_system,
            is_need_choice_code_prefix: this.is_need_choice_code_prefix,
            choice_code_prefix: this.choice_code_prefix,
            choice_code_prefix_type: this.choice_code_prefix_type,
            choice_code_prefix_sep: this.choice_code_prefix_sep,
            choice_code_len: this.choice_code_len,
            choice_code_start: this.choice_code_start,
            choice_code_type: this.choice_code_type,
            is_need_choice_code_suffix: this.is_need_choice_code_suffix,
            choice_code_suffix: this.choice_code_suffix,
            choice_code_suffix_type: this.choice_code_suffix_type,
            initials_len: this.initials_len,
            is_initials_len_enforce: this.is_initials_len_enforce,
            is_same: this.is_same,
            is_random_code_system: this.is_random_code_system,
            is_need_random_code_prefix: this.is_need_random_code_prefix,
            random_code_prefix: this.random_code_prefix,
            random_code_prefix_type: this.random_code_prefix_type,
            random_code_prefix_sep: this.random_code_prefix_sep,
            random_code_len: this.random_code_len,
            random_code_start: this.random_code_start,
            random_code_type: this.random_code_type,
            is_need_random_code_suffix: this.is_need_random_code_suffix,
            random_code_suffix: this.random_code_suffix,
            random_code_suffix_type: this.random_code_suffix_type,
            choice_code_another_name: this.choice_code_another_name,
            random_code_another_name: this.random_code_another_name,
            initials_another_name: this.initials_another_name,
            is_subject_show_system: this.is_subject_show_system,
            is_subject_show_time: this.is_subject_show_time,
            is_subject_show_user: this.is_subject_show_user,
            is_urgently_unblind_show_system:
              this.is_urgently_unblind_show_system,
            is_urgently_unblind_show_time: this.is_urgently_unblind_show_time,
            is_urgently_unblind_show_user: this.is_urgently_unblind_show_user,
            // in_group_time_name: this.in_group_time_name,
            // is_fix_in_group_time: this.is_fix_in_group_time,
          };
          this.add(params);
        }
      }
    },
    add(params) {
      setFront(params.is_choice_code_system);
      setAfter(params.is_random_code_system);
      Promise.all([dataSetting(params), dataSettingTwo(params)])
        .then((res) => {
          if (res[0] && res[0].code === 0) {
            this.$message({
              message: res[0].msg,
              type: "success",
            });
            this.getData();
          } else {
            this.$message(res[0].msg);
          }
        })
        .catch((res) => {
          console.log(res.msg);
        });
    },
  },
};
</script>

<style scoped>
.setting {
  margin-bottom: 30px;
}

.title {
  font-size: 16px;
  color: #595959;
  font-weight: 500;
  margin-bottom: 10px;
}

.item {
  padding: 10px 0;
}

.detail {
  margin: 0 30px;
}

.right {
  /*text-align: right;*/
  line-height: 26px;
  /*border: 1px solid red;*/
}

.circle {
  width: 8px;
  height: 8px;
  background-color: #8eb1ff;
  border-radius: 50%;
  display: inline-block;
  margin-right: 5px;
}

.first {
  padding-bottom: 20px;
  border-bottom: 1px dashed #bfbfbf;
}

.two {
  margin-top: 20px;
  border-bottom: 1px dashed #bfbfbf;
}

.three {
  border-bottom: 1px dashed #bfbfbf;
  padding: 15px 0;
}

.four {
  margin-top: 30px;
  padding-bottom: 20px;
  border-bottom: 1px dashed #bfbfbf;
}

.rights {
  line-height: 26px;
}

.footer {
  text-align: center;
  margin-top: 30px;
}

.detailTitle {
  font-size: 15px;
  font-weight: 500;
}

.el-button:first-child {
  width: 6.2%;
  margin-right: 20px;
}

.detailBox {
  margin-bottom: 30px;
}
</style>
